import { Alert, Button } from "@mui/material";
import Box from "@mui/material/Box";
import { FormProviderAndElement } from "app/components/form/FormProviderAndElement";
import { PasswordFieldElement } from "app/components/form/PasswordFieldElement";
import { TextFieldElement } from "app/components/form/TextFieldElement";
import { useCallback, useState } from "react";

import { useAuthStore } from "../hooks/useAuthStore";

type LoginFormValues = {
  password: string;
  username: string;
};

export const LoginForm = () => {
  const [loginError, setLoginError] = useState<null | string>(null);
  const [loading, setLoading] = useState(false);
  const { login } = useAuthStore();

  const onLoginSubmit = useCallback(
    async (data: LoginFormValues) => {
      setLoginError(null);
      setLoading(true);

      const loginResponse = await login(data.username, data.password);
      setLoading(false);
      if (loginResponse?.error) {
        setLoginError(loginResponse?.error);
      }
    },
    [login],
  );

  return (
    <FormProviderAndElement<LoginFormValues>
      formName="Login"
      formProps={{
        defaultValues: {
          password: "",
          username: "",
        },
      }}
      onSubmitValidData={onLoginSubmit}
    >
      {loginError && (
        <Alert severity="error" sx={{ mb: 5 }}>
          {loginError}
        </Alert>
      )}
      <Box alignItems="flex-end" display="flex" flexDirection="column">
        <TextFieldElement
          fieldName="username"
          fullWidth
          label="Login"
          placeholder="Přihlašovací jméno..."
          required
          rules={{
            required: "Přihlašovací jméno je povinné.",
          }}
          slotProps={{
            inputLabel: { shrink: true },
          }}
          sx={{ mb: 3 }}
        />
        <PasswordFieldElement
          fieldName="password"
          fullWidth
          label="Heslo"
          required
          slotProps={{
            inputLabel: { shrink: true },
          }}
          sx={{ mb: 3 }}
        />

        <Button
          color="inherit"
          fullWidth
          loading={loading}
          size="large"
          type="submit"
          variant="contained"
        >
          Přihlásit se
        </Button>
      </Box>
    </FormProviderAndElement>
  );
};
